import { useMediaQuery } from 'ui/Hooks';

import { MediaQueryContext } from '../../contexts/mediaQueryContext';

type Props = {
  children: React.ReactNode;
};

const MediaQueryProvider: React.FC<Props> = ({ children }) => {
  const [isScreenWiderThan480] = useMediaQuery(['(min-width: 480px)'], {
    fallback: [false],
  });
  const [isDesktopScreen] = useMediaQuery(['(min-width: 1280px)'], {
    fallback: [false],
  });
  return (
    <MediaQueryContext.Provider
      value={{ isScreenWiderThan480, isDesktopScreen }}
    >
      {children}
    </MediaQueryContext.Provider>
  );
};

export default MediaQueryProvider;
